<template>
  <div class="r-alertas-bell">
    <f7-button
      small
      class="display-flex r-alertas-bell-btn"
      :icon-f7="countNoLeidas > 0 ? 'bell_fill' : 'bell'"
      @click="togglePopover"
    >
      <span v-if="countNoLeidas > 0" class="r-alertas-bell-badge">{{ countNoLeidas }}</span>
    </f7-button>

    <f7-popover ref="popover" class="r-alertas-popover">
      <div class="r-alertas-header">
        <div class="r-alertas-title">Alertas</div>
        <div class="r-alertas-header-actions">
          <f7-link v-if="selectedCount > 0" small color="red" @click="eliminarSeleccionadas">
            Eliminar ({{ selectedCount }})
          </f7-link>
          <f7-link v-if="alertas.length" small @click="recargar">
            <i class="f7-icons" style="font-size: 16px;">arrow_clockwise</i>
          </f7-link>
        </div>
      </div>
      <div class="r-alertas-filtros">
        <input
          type="text"
          class="r-alertas-filtro-texto"
          placeholder="Buscar en las alertas…"
          v-model="filtroTexto"
          @input="onFiltroTextoInput"
        />
        <div class="r-alertas-seg">
          <button
            type="button"
            class="r-alertas-seg-btn"
            :class="{ 'r-alertas-seg-btn--active': filtroEstado === 'LEIDAS' }"
            @click="setFiltroEstado('LEIDAS')"
          >Leídas</button>
          <button
            type="button"
            class="r-alertas-seg-btn"
            :class="{ 'r-alertas-seg-btn--active': filtroEstado === 'TODAS' }"
            @click="setFiltroEstado('TODAS')"
          >Todas</button>
          <button
            type="button"
            class="r-alertas-seg-btn"
            :class="{ 'r-alertas-seg-btn--active': filtroEstado === 'PENDIENTES' }"
            @click="setFiltroEstado('PENDIENTES')"
          >Pendientes</button>
        </div>
        <div class="r-alertas-filtros-checks">
          <label v-if="alertas.length" class="r-alertas-filtro-check">
            <input type="checkbox" :checked="todoSeleccionado" @change="toggleSeleccionarTodo" />
            Seleccionar todo
          </label>
        </div>
      </div>
      <div class="r-alertas-list" @scroll.passive="onListScroll">
        <div v-if="loading" class="r-alertas-empty">Cargando…</div>
        <div v-else-if="!alertas.length" class="r-alertas-empty">No tienes alertas</div>
        <div
          v-else
          v-for="(a, index) in alertas"
          :key="a.id"
          class="r-alertas-item"
          :class="['r-alertas-item--' + (a.nivel || 'INFO').toLowerCase(), { 'r-alertas-item--leida': esLeida(a) }]"
          @click="onClickAlerta(a)"
        >
          <div class="r-alertas-item-row">
            <input
              type="checkbox"
              class="r-alertas-item-check"
              :checked="isSelected(a)"
              @click.stop
              @change="toggleSelect(a)"
            />
            <i class="f7-icons r-alertas-item-icon">{{ iconForNivel(a.nivel) }}</i>
            <div class="r-alertas-item-body">
              <div class="r-alertas-item-titulo">{{ a.titulo || '(sin título)' }}</div>
              <div class="r-alertas-item-mensaje">{{ a.mensaje }}</div>
              <div class="r-alertas-item-meta">
                <span class="r-alertas-item-idx">#{{ index + 1 }}</span>
                <span v-if="a.origen"> · {{ a.origen }}</span>
                <span v-if="a.fecha"> · {{ formatFecha(a.fecha) }}</span>
              </div>
            </div>
            <div class="r-alertas-item-actions">
              <f7-link v-tooltip="'Eliminar'" color="red" @click.stop="eliminar(a)">
                <i class="f7-icons" style="font-size: 16px;">trash</i>
              </f7-link>
            </div>
          </div>
        </div>
        <div v-if="loadingMore" class="r-alertas-empty">Cargando más…</div>
      </div>
    </f7-popover>
  </div>
</template>

<script>
import Alerta from '../js/db/Alerta.js';
import AlertasEvents from '../js/db/AlertasEvents.js';
import { EventBus } from '../js/EventBus';
import cerrojoDeLaSesion from '../js/utils/cerrojoDeLaSesion.js';
import RoutesUtils from '../js/RoutesUtils.js';

/** Lo más largo que se deja a un toast de alerta; el resto se lee en la campana (#1210). */
const MAX_TOAST = 160;

export default {
  name: 'rAlertasBell',
  data() {
    return {
      countNoLeidas: 0,
      alertas: [],
      loading: false,
      loadingMore: false,
      hasMore: true,
      perPage: 20,
      selected: {},
      filtroTexto: '',
      filtroEstado: 'TODAS', // 'LEIDAS' | 'TODAS' | 'PENDIENTES'
      _filtroTimer: null,
      _handler: null
    };
  },
  computed: {
    selectedCount() {
      const self = this;
      return Object.keys(self.selected).filter(function(k){ return self.selected[k]; }).length;
    },
    todoSeleccionado() {
      const self = this;
      return self.alertas.length > 0 && self.alertas.every(function(a){ return !!self.selected[a.id]; });
    }
  },
  methods: {
    iconForNivel(nivel) {
      switch ((nivel || '').toUpperCase()) {
        case 'ERROR': return 'xmark_octagon_fill';
        case 'WARN':  return 'exclamationmark_triangle_fill';
        default:      return 'info_circle_fill';
      }
    },
    formatFecha(fecha) {
      try {
        const d = new Date(fecha);
        const p = (n) => n < 10 ? '0' + n : n;
        return p(d.getDate()) + '/' + p(d.getMonth() + 1) + '/' + d.getFullYear() + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
      } catch (e) {
        return '' + fecha;
      }
    },
    actualizarCount() {
      const self = this;
      Alerta.countNoLeidas()
        .then(function(res) {
          self.countNoLeidas = (res && (res.dto != null ? res.dto : res)) || 0;
        })
        .catch(function(){ /* noop */ });
    },
    extractList(res) {
      return (res && (res.list != null ? res.list : (res.dto != null ? res.dto : res))) || [];
    },
    cargar(opts) {
      const self = this;
      const silent = !!(opts && opts.silent);
      // #663 · Cerrojo de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que lo soltaba.
      if (!silent) cerrojoDeLaSesion(self, 'loading');
      // Primera página: reemplaza la lista y resetea la paginación y la selección.
      Alerta.mias(0, self.perPage, self.filtroTexto, self.filtroEstado === 'PENDIENTES', self.filtroEstado === 'LEIDAS').then(function(res) {
        const list = self.extractList(res);
        self.alertas = list;
        self.hasMore = list.length >= self.perPage;
        self.selected = {};
        self.loading = false;
      }).catch(function(){
        self.loading = false;
      });
    },
    loadMore() {
      const self = this;
      if (self.loadingMore || !self.hasMore) {
        return;
      }
      cerrojoDeLaSesion(self, 'loadingMore');
      // El offset es el nº de alertas ya cargadas (se autoajusta con altas/bajas locales).
      Alerta.mias(self.alertas.length, self.perPage, self.filtroTexto, self.filtroEstado === 'PENDIENTES', self.filtroEstado === 'LEIDAS').then(function(res) {
        const list = self.extractList(res);
        const existing = {};
        self.alertas.forEach(function(a){ existing[a.id] = true; });
        var added = 0;
        list.forEach(function(n){ if (!existing[n.id]) { self.alertas.push(n); added++; } });
        // Si la pagina viene incompleta o no aporta nada nuevo, no hay mas (evita bucles).
        self.hasMore = list.length >= self.perPage && added > 0;
        self.loadingMore = false;
      }).catch(function(){
        self.loadingMore = false;
      });
    },
    onListScroll(event) {
      const el = event && event.target;
      if (!el) {
        return;
      }
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 48) {
        this.loadMore();
      }
    },
    esLeida(a) {
      // El backend calcula `leida` por usuario (estado LEIDA en individuales, o username en
      // leidaPor para las de rol). _leida/estado son respaldo para el update optimista local.
      return !!(a && (a.leida || a._leida || a.estado === 'LEIDA'));
    },
    onClickAlerta(a) {
      if (!a) return;
      // #1210 · La alerta de festivos lleva a donde está el detalle, si esa pantalla se puede abrir
      // (regla §9: sin la ruta en el menú efectivo, no hay enlace que lleve a un 403).
      if (this.esDeFestivos(a) && RoutesUtils.tieneAcceso('/festivos/', ['ADMIN', 'DIRECTOR'])) {
        if (!this.esLeida(a)) this.marcarLeida(a);
        if (this.$refs.popover) this.$refs.popover.close();
        this.$f7.views.main.router.navigate('/festivos/?avisos=1');
        return;
      }
      if (this.esLeida(a)) return;
      this.marcarLeida(a);
    },
    esDeFestivos(a) {
      return !!a && a.origen === 'FESTIVOS';
    },
    /**
     * El texto del toast, acotado (#1210). El toast se pinta encima de la cabecera: con el mensaje
     * entero, un aviso largo —el de festivos llevaba veinticuatro municipios— tapaba la pantalla.
     * El texto completo sigue en la campana.
     */
    textoToast(payload) {
      const texto = (payload.titulo || 'Alerta') + (payload.mensaje ? ': ' + payload.mensaje : '');
      return texto.length > MAX_TOAST ? texto.slice(0, MAX_TOAST - 1).trimEnd() + '…' : texto;
    },
    recargar() {
      this.cargar({ silent: true });
      this.actualizarCount();
    },
    togglePopover(e) {
      const target = e && e.currentTarget ? e.currentTarget : e.target;
      this.$refs.popover.open(target);
      this.cargar();
      // Refresca el contador con la verdad del servidor cada vez que se abre.
      this.actualizarCount();
    },
    marcarLeida(a) {
      const self = this;
      if (self.esLeida(a)) return;
      // Update optimista en sitio (sin recargar la lista) para que no parpadee:
      // se queda en blanco al instante y el servidor se actualiza en segundo plano.
      self.$set(a, 'leida', true);
      self.$set(a, '_leida', true);
      if (self.countNoLeidas > 0) self.countNoLeidas--;
      Alerta.marcarLeida(a.id).catch(function(){
        self.$set(a, 'leida', false);
        self.$set(a, '_leida', false);
        self.countNoLeidas++;
      });
    },
    eliminar(a) {
      const self = this;
      const esRol = !!a.rolDestinatario;
      const texto = esRol
        ? 'Esta alerta es de tu rol. Si la eliminas, se eliminará también para el resto de tus compañeros con el mismo rol. ¿Continuar?'
        : '¿Seguro que quieres eliminar esta alerta?';
      self.$f7.dialog.confirm(texto, 'Eliminar alerta', function() {
        self.doEliminar(a);
      });
    },
    doEliminar(a) {
      const self = this;
      const estabaNoLeida = !self.esLeida(a);
      Alerta.eliminar(a.id).then(function() {
        self.quitarLocal(a.id, estabaNoLeida);
      }).catch(function(){ /* noop */ });
    },
    isSelected(a) {
      return !!this.selected[a.id];
    },
    toggleSelect(a) {
      this.$set(this.selected, a.id, !this.selected[a.id]);
    },
    toggleSeleccionarTodo() {
      const self = this;
      const marcar = !self.todoSeleccionado;
      self.alertas.forEach(function(a){ self.$set(self.selected, a.id, marcar); });
    },
    onFiltroTextoInput() {
      const self = this;
      clearTimeout(self._filtroTimer);
      self._filtroTimer = setTimeout(function(){ self.aplicarFiltros(); }, 300);
    },
    setFiltroEstado(estado) {
      if (this.filtroEstado === estado) return;
      this.filtroEstado = estado;
      this.aplicarFiltros();
    },
    aplicarFiltros() {
      // Recarga desde la primera página con los filtros actuales.
      this.cargar({ silent: true });
    },
    eliminarSeleccionadas() {
      const self = this;
      const ids = Object.keys(self.selected).filter(function(k){ return self.selected[k]; });
      if (!ids.length) return;
      const seleccionadas = self.alertas.filter(function(a){ return self.selected[a.id]; });
      const hayRol = seleccionadas.some(function(a){ return !!a.rolDestinatario; });
      const texto = (hayRol
        ? 'Algunas de las alertas seleccionadas son de tu rol: se eliminarán también para el resto de tus compañeros con el mismo rol. '
        : '') + '¿Eliminar ' + ids.length + ' alerta(s)?';
      self.$f7.dialog.confirm(texto, 'Eliminar alertas', function() {
        self.doEliminarMultiples(ids);
      });
    },
    doEliminarMultiples(ids) {
      const self = this;
      // Nº de no leídas entre las seleccionadas, para ajustar el contador.
      var noLeidas = 0;
      ids.forEach(function(id){
        var a = self.alertas.find(function(x){ return x.id === id; });
        if (a && !self.esLeida(a)) noLeidas++;
      });
      Alerta.eliminarMultiples(ids).then(function() {
        ids.forEach(function(id){
          var idx = -1;
          for (var j = 0; j < self.alertas.length; j++) {
            if (self.alertas[j].id === id) { idx = j; break; }
          }
          if (idx !== -1) self.alertas.splice(idx, 1);
          self.$set(self.selected, id, false);
        });
        self.countNoLeidas = Math.max(0, self.countNoLeidas - noLeidas);
      }).catch(function(){ /* noop */ });
    },
    quitarLocal(id, estabaNoLeida) {
      const self = this;
      var idx = -1;
      for (var j = 0; j < self.alertas.length; j++) {
        if (self.alertas[j].id === id) { idx = j; break; }
      }
      if (idx !== -1) self.alertas.splice(idx, 1);
      self.$set(self.selected, id, false);
      if (estabaNoLeida && self.countNoLeidas > 0) self.countNoLeidas--;
    },
    onAlertaIncoming(payload) {
      if (!payload) return;
      // La nueva alerta es la más reciente: la insertamos arriba (sin recargar, compatible
      // con el scroll infinito) si no estaba ya.
      const dto = payload.dto || payload;
      if (dto && dto.id && !this.alertas.some(function(a){ return a.id === dto.id; })) {
        this.alertas.unshift(dto);
      }
      this.actualizarCount();
      // #1210 · El aviso de festivos no salta como toast: es un estado que dura semanas y ya lo
      // cuenta el indicador de la cabecera. Entra en la campana, sin más.
      if (this.esDeFestivos(dto) || this.esDeFestivos(payload)) return;
      // Toast pequeño
      try {
        const self = this;
        self.$f7.toast.create({
          icon: '<i class="f7-icons">' + this.iconForNivel(payload.nivel) + '</i>',
          text: self.textoToast(payload),
          position: 'top',
          closeTimeout: 4000,
          destroyOnClose: true
        }).open();
      } catch (e) { /* noop */ }
    },
    _connect() {
      if (this._connected) return;
      this._connected = true;
      this.actualizarCount();
      AlertasEvents.subscribe(this._handler);
    },
    _disconnect() {
      if (!this._connected) return;
      this._connected = false;
      AlertasEvents.unsubscribe(this._handler);
      this.countNoLeidas = 0;
      this.alertas = [];
    }
  },
  mounted() {
    this._handler = this.onAlertaIncoming.bind(this);
    this._authReadyHandler = () => this._connect();
    this._sessionCloseHandler = () => this._disconnect();
    // app:auth-ready se emite tras request.setup({Authorization}) tanto en
    // startSession (recarga / F5 / nueva pestaña) como en saveSession (login).
    // Sin gatear por este evento, mounted() correría antes de que
    // Framework7.request tenga el header → 401 → interceptor global limpia sesión.
    EventBus.$on('app:auth-ready', this._authReadyHandler);
    EventBus.$on('app:session:close', this._sessionCloseHandler);
  },
  beforeDestroy() {
    EventBus.$off('app:auth-ready', this._authReadyHandler);
    EventBus.$off('app:session:close', this._sessionCloseHandler);
    clearTimeout(this._filtroTimer);
    this._disconnect();
  }
};
</script>

<style scoped>
.r-alertas-bell {
  position: relative;
  display: inline-flex;
}
.r-alertas-bell-btn {
  position: relative;
}
.r-alertas-bell-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: #c62828;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  pointer-events: none;
}
.r-alertas-popover {
  width: 360px;
  max-width: 90vw;
}
.r-alertas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(0,0,0,0.08);
  background: #22355b;
  color: #fff;
}
.r-alertas-title {
  font-weight: 600;
  font-size: 14px;
}
.r-alertas-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.r-alertas-item-check {
  margin-top: 3px;
  flex-shrink: 0;
  cursor: pointer;
}
.r-alertas-filtros {
  padding: 8px 12px;
  border-bottom: 1px solid rgba(0,0,0,0.08);
  background: #f7f7f9;
}
.r-alertas-filtro-texto {
  width: 100%;
  box-sizing: border-box;
  padding: 6px 10px;
  border: 1px solid rgba(0,0,0,0.18);
  border-radius: 6px;
  font-size: 13px;
  outline: none;
}
.r-alertas-seg {
  display: flex;
  margin-top: 8px;
  border: 1px solid rgba(0,0,0,0.18);
  border-radius: 7px;
  overflow: hidden;
  background: #fff;
}
.r-alertas-seg-btn {
  flex: 1 1 0;
  border: 0;
  background: transparent;
  padding: 6px 4px;
  font-size: 12px;
  color: #495057;
  cursor: pointer;
  border-left: 1px solid rgba(0,0,0,0.1);
}
.r-alertas-seg-btn:first-child {
  border-left: 0;
}
.r-alertas-seg-btn--active {
  background: #22355b;
  color: #fff;
  font-weight: 600;
}
.r-alertas-filtros-checks {
  display: flex;
  gap: 14px;
  margin-top: 8px;
}
.r-alertas-filtro-check {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #495057;
  cursor: pointer;
}
.r-alertas-list {
  max-height: 60vh;
  overflow-y: auto;
}
.r-alertas-empty {
  padding: 18px;
  text-align: center;
  color: #6c757d;
  font-size: 13px;
}
.r-alertas-item {
  padding: 8px 12px;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  border-left: 3px solid transparent;
  /* No leída: fondo sepia. Al marcarla leída pasa a blanco. */
  background: #efe2c2;
  cursor: pointer;
  transition: background-color 0.2s ease, opacity 0.2s ease;
}
.r-alertas-item--info  { border-left-color: #2196f3; }
.r-alertas-item--warn  { border-left-color: #ff9800; }
.r-alertas-item--error { border-left-color: #c62828; }
.r-alertas-item--leida { background: #fff; cursor: default; opacity: 0.7; }
.r-alertas-item-row {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}
.r-alertas-item-icon {
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 2px;
}
.r-alertas-item--info  .r-alertas-item-icon { color: #2196f3; }
.r-alertas-item--warn  .r-alertas-item-icon { color: #ff9800; }
.r-alertas-item--error .r-alertas-item-icon { color: #c62828; }
.r-alertas-item-body {
  flex: 1 1 auto;
  min-width: 0;
}
.r-alertas-item-titulo {
  font-weight: 600;
  font-size: 13px;
  color: #212529;
}
.r-alertas-item-mensaje {
  font-size: 12px;
  color: #495057;
  word-break: break-word;
}
.r-alertas-item-meta {
  font-size: 11px;
  color: #868e96;
  margin-top: 2px;
}
.r-alertas-item-actions {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
}
</style>
